<app-header></app-header>


<!-- ======= Hero Section ======= -->
<section id="hero" class="hero_slide cust-hero-slider">
  <div data-bs-interval="5000" class="" data-bs-ride="carousel">
    <!-- Slide 1 -->
    <div class="container">
      <div class="row">
        <div class="col-lg-6 col-md-6 mt-5 cust-slider-left-text pad_top_30">
          <h2 class="animate__animated animate__fadeInDown text-alignment-center">Energy Monitoring<br class="text_hide"/> System</h2>
          <p class="animate__animated animate__fadeInUp width-100 m-0 text-alignment-center">Real-time data gathering,
            analytics & insights<br class="text_hide">
            help industries reduce their power usage.</p>
          <div class="flex_center pad-top-25">
            <a href="https://www.samyak.com/contact-us/"
              class="btn-get-started animate__animated animate__fadeInUp scrollto margin-top-25 cursor_pointer text-alignment">Contact
              Us</a>
          </div>
        </div>
        <div class="col-lg-6 col-md-6 text-right">
          <img src="assets/img/slide-1.svg" class="slider-img-level slider-img">
        </div>
      </div>


    </div>
  </div>
</section><!-- End Hero -->

<main id="main">
  <section id="clients" class="clients">
    <div class="container p-0">
      <div class="row client-logo-main">
        <div class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
          <img src="../../assets/img/Adani-power-logo.svg" class="img-fluid" alt="">
        </div>

        <div class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
          <img src="../../assets/img/Cognitive Technologies.svg" class="img-fluid" alt="">
        </div>

        <div class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
          <img src="../../assets/img/Anodyne Technologies.svg" class="img-fluid" alt="">
        </div>

        <div class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
          <img src="../../assets/img/Energy Doctor (Tricolite Energy Soln).svg" class="img-fluid" alt="">
        </div>

        <div class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
          <img src="../../assets/img/Navi mumbai corporation.svg" class="img-fluid" alt="">
        </div>

        <div class="col-lg-2 col-md-4 col-2 d-flex align-items-center justify-content-center cust-padding-7">
          <img src="../../assets/img/rech.svg" class="img-fluid" alt="">
        </div>

      </div>

    </div>
  </section>

  <section id="services" class="services">
    <div class="container aos-init aos-animate" data-aos="fade-up">

      <div class="section-title">

        <p class="pt-4 pb-4">What are the challenges do manufacturer face?</p>

      </div>




      <div class="align-items-center text-center justify-content-center">
        <img src="assets/img/Energy-Monitoring-System.gif" alt="">
      </div>

    </div>
  </section>

  <section id="cta" class="cta space-comman">

    <div class="container aos-init aos-animate" data-aos="zoom-in">
      <div class="row display_two_column">
        <div class="first_column_image pb-3">
          <img src="assets/img/iot-chart.svg">
        </div>
        <div class="second_column_text">
          <div class="second_column_image">
            <h3 class="text-left">What are Energy monitoring solutions?</h3>
            <p class="mt-30 text_jus">With Energy Monitoring solutions, you can remotely monitor and analyze daily,
              monthly, weekly or yearly reports of energy consumption through meter reading. It will help in automating
              meter readings and generating electricity bills.




            </p>
            <p class="mt-30 text_jus">
              Samyak's IIoT device gets connected to field sensors like temp, humidiy. Device gets connected to
              energy-meter as well. From there it takes data and send it to cloud. This will allow you to access the
              sensor information on mobile phones as well as desktops.</p>

          </div>
        </div>
      </div>
    </div>
  </section>

  <section id="Advanced Energy" class="services">
    <div class="container aos-init aos-animate" data-aos="fade-up">
      <div class="row display_two_column-1">
        <div class="second_column_text">
          <div class="second_column_image">
            <div class="section-title Energy-Analytics-title">

              <p class="heading-left pad-top-desk">Brief overview of the system</p>

            </div>
            <ul class="overview list_item">
              <li>The management of your tanks: functional characteristics, dimensions, volume, location.




              </li>
              <li>Real-time monitoring of the level of each tank.</li>
              <li>The evolution of the level of the tank over time, with the events of filling or emptying.</li>
              <li>Threshold definition (up, down) for alert generation (email, SMS).</li>
              <li>The preparation of purchase orders for the company in charge of filling or emptying the vats.</li>
              <li>Custom Alrams,alert messages can be set.</li>
              <li>Generating reports on all the tanks, or for a tank.</li>
            </ul>
          </div>
        </div>
        <div class="first_column_image pb-3">
          <div class="align-items-center text-center justify-content-center pad_27">

            <img class="embed-responsive-item" src="assets/img/energy_monitoring_brief.svg">

          </div>
        </div>
      </div>
    </div>
  </section>


  <section id="How-Rms-Works" class="services gray-container space-comman padding-bottom-50 margin-bottom-0">
    <div class="container aos-init aos-animate" data-aos="fade-up">

      <div class="section-title">

        <p class="pt-4">Energy monitoring solutions Application area</p>

      </div>

      <div class="row pad_15">

        <div class="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 aos-init">
          <div class="icon-box height-300 w_100">
            <div class="icon-container pb-3"><img src="assets/img/energy.svg" class="icon_img_mobile"></div>
            <h4><a href="">Energy Consumption Monitoring</a></h4>
            <p class="text_jus" style="margin-bottom: 0px !important;">Energy consumed by machines can be monitored and
              managed regularly by our smart energy monitoring solutions.</p>
          </div>
        </div>

        <div class="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 aos-init" data-aos-delay="300">
          <div class="icon-box height-300 w_100">
            <div class="icon-container pb-3"><img src="assets/img/configuration.svg" class="icon_img_mobile"></div>
            <h4><a href="">Facilities’ Efficiency Improvement</a></h4>
            <p class="text_jus" style="margin-bottom: 0px !important;">Intellia IoT Energy Monitoring System provides an
              easy way to automatically retrieve and analyze power quality events. </p>
          </div>
        </div>


        <div class="col-lg-4 col-md-6 d-flex align-items-stretch mt-4 aos-init" data-aos-delay="300">
          <div class="icon-box height-300 w_100">
            <div class="icon-container pb-3"><img src="assets/img/graph.svg" class="icon_img_mobile"></div>
            <h4><a href="">Equipment Availability Monitoring</a></h4>
            <p class="text_jus" style="margin-bottom: 0px !important;"> With our Energy Monitoring System, you will get
              real-time insights into your machine’s availability and performance.</p>
          </div>
        </div>


      </div>
    </div>
  </section>

  <section id="services" class="services">
    <div class="container aos-init aos-animate" data-aos="fade-up">

      <div class="section-title">

        <p class="pt-4">Energy Monitoring Benefits</p>

      </div>

      <div class="align-items-center text-center justify-content-center mt-30">
        <img src="assets/img/Flow-Moni_GIF.gif" class="img-fluid" alt="">
      </div>

    </div>
  </section>

  <section id="testimonials" class="testimonials section-bg services mt-30 ">
    <div class="container aos-init aos-animate" data-aos="fade-up">

      <div class="section-title">

        <p class="pt-4 pad_15">Custom Report and Dashboard For Flow Monitoring </p>

      </div>

      <div class="best_service">
        <owl-carousel [options]="SlideOptions3" [carouselClasses]="['owl-theme', 'sliding']">
          <div class="item" *ngFor="let img of Images1">
            <div style="align-content: center">
              <div class="icon-box icon-box2 icon-box3">
                <div class="icon-container"><img src="{{img.img}}"></div>
                <h4><a class="font-weight-500" href="">{{img.title}}</a></h4>
                <p>{{img.text}}<span></span></p>

              </div>
            </div>
          </div>
        </owl-carousel>
      </div>
    </div>
  </section>


  <section id="testimonials" class="industries testimonials section-bg services">
    <div class="container aos-init aos-animate" data-aos="fade-up">

      <div class="section-title">

        <p class="pt-3" style="color: #fff;">Industries We Serve</p>

      </div>

      <div class="best_service">
        <owl-carousel [options]="SlideOptions2" [carouselClasses]="['owl-theme', 'sliding']">
          <div class="item" *ngFor="let img of Images2">
            <div class="">
              <div class="icon-container34">
                <p><img class="indus-img" src="{{img.img}}"></p>
                <div class="h3">{{img.title}}</div>
              </div>
            </div>
          </div>
        </owl-carousel>
      </div>

    </div>
  </section>




  <section id="testimonial-area" class="pt-5 padding-bottom-new">

    <div class="container">
        <div class="mx-auto">
            <header class="section-header text-center">

                <h2  class="m_top">What our Customers are Saying</h2>
            </header>
        </div>
        <div class="testimonial-block" style="padding-bottom: 40px; padding-top: 45px;">
            <div style="width: 428px;" class="image_display"><img src="assets/img/user5.svg" alt=""
                    class="testimonial_img"></div>

            <div class="padding-both-side">

                <h1> <span><img src="../../assets/img/comma.svg" class="commam"></span></h1>
                <p class="text_align_center" style="font-size: 14px;">“Samyak's support is really good and we are
                    very happy with the services they have provided to us like hardware data integration through GSM
                    gateways. Two way communication is helping us a big time. We heartily appreciate all kind of
                    support.”</p>
                <div class="testimonial">
                    <p class="testimonialFrom text_align_center" style="font-size: 14px;">Jummal Popis</p>
                    <p class="text_align_center" style="font-size: 14px;">Founder Circle</p>
                </div>
            </div>
        </div>



    </div>

</section>

  <app-latest-article></app-latest-article>


</main>

<app-footer></app-footer>